import { verifyReportModelExists } from '../../api/report-model-designer';
import {
  ALPHANUMERIC_VALIDATION_TEXT,
  REQUIRED_VALIDATION_TEXT,
  SPECIAL_CHARS,
} from '../../constants/Common';
import { isNilOrEmpty } from '../../utils/ramdaUtils';

export const validateProp = ({ propValue }) => {
  const error = {};
  if (isNilOrEmpty(propValue)) {
    error.hasError = true;
    error.errorText = REQUIRED_VALIDATION_TEXT;
  } else if (SPECIAL_CHARS.test(propValue)) {
    error.hasError = true;
    error.errorText = ALPHANUMERIC_VALIDATION_TEXT;
  } else {
    error.hasError = false;
    error.errorText = '';
  }
  return error;
};

export const validateNewReportModalOnBlur = ({ reportSettings, propName, modalErrors }) => {
  const errors = { ...modalErrors };

  const propError = validateProp({ propValue: reportSettings[propName] });
  errors[propName] = { ...propError };

  return errors;
};

export const validateNewReportModalOnCreate = async ({ reportName }) => {
  const errors = { reportName: {} };

  if (!reportName.length) {
    errors.reportName.hasError = true;
    errors.reportName.errorText = 'This field is required';
  }

  if (errors.reportName.hasError) {
    return errors;
  }

  const { resource: isReportExist } = await verifyReportModelExists(reportName);

  if (isReportExist) {
    errors.reportName.hasError = true;
    errors.reportName.errorText = 'This report model already exists';
  }

  return errors;
};
